import styled from 'styled-components';

export const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: #1d1e2b;
  font-family: 'Montserrat';
`;
